import { ARMORY_PUBLIC_URL, PLAYER_HUB_URL } from '@/config/externalLinks'

export default function Footer() {
  return (
    <footer className="border-t border-calamity-border-subtle/50 bg-calamity-bg-dark/60">
      <div className="max-w-[1500px] mx-auto px-4 py-6 sm:px-6 sm:py-8">
        <div className="grid grid-cols-2 gap-x-6 gap-y-8 lg:grid-cols-4">
          <div className="flex flex-col gap-2">
            <h4 className="text-xs font-bold uppercase tracking-wider text-calamity-text-dim">
              Collections
            </h4>
            <a
              href="https://opensea.io/collection/calamity-cosmetics"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-calamity-text-muted hover:text-calamity-accent transition-colors"
            >
              Cosmetics (OpenSea)
            </a>
            <a
              href="https://marketplace.roninchain.com/collections/calamity-cosmetics"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-calamity-text-muted hover:text-calamity-accent transition-colors"
            >
              Cosmetics (Ronin)
            </a>
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="text-xs font-bold uppercase tracking-wider text-calamity-text-dim">
              Dragon Rings
            </h4>
            <a
              href="https://opensea.io/collection/calamity-artifacts-official"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-calamity-text-muted hover:text-calamity-accent transition-colors"
            >
              Calamity Artifacts (OpenSea)
            </a>
            <a
              href="https://opensea.io/collection/dragon-ring"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-calamity-text-muted hover:text-calamity-accent transition-colors"
            >
              Dragon Rings (OpenSea)
            </a>
            <a
              href="https://marketplace.roninchain.com/collections/dragon-ring"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-calamity-text-muted hover:text-calamity-accent transition-colors"
            >
              Dragon Rings (Ronin)
            </a>
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="text-xs font-bold uppercase tracking-wider text-calamity-text-dim">
              Resources
            </h4>
            <a
              href={PLAYER_HUB_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-calamity-text-muted hover:text-calamity-accent transition-colors"
            >
              Player Hub
            </a>
            <a
              href={ARMORY_PUBLIC_URL}
              className="text-xs text-calamity-text-muted hover:text-calamity-accent transition-colors"
            >
              Armory
            </a>
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="text-xs font-bold uppercase tracking-wider text-calamity-text-dim">
              Community
            </h4>
            <a
              href="https://discord.gg/n3uBgxpTmE"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-calamity-text-muted hover:text-calamity-accent transition-colors"
            >
              Discord
            </a>
            <a
              href="https://x.com/PlayCalamity"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-calamity-text-muted hover:text-calamity-accent transition-colors"
            >
              X (Twitter)
            </a>
          </div>
        </div>

      </div>
    </footer>
  )
}
